{
    "columns":[
		{
			"header_id": "batchName",
			"header_label": "Batch Name",
			"jsonpath":  "batchName" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "tasBillingBatchFileMasterId",
			"header_label": "File Id",
			"jsonpath":  "tasBillingBatchFileMasterId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "fileName",
			"header_label": "File Name",
			"jsonpath":  "fileName" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "n"
		},
		{
			"header_id": "fileType",
			"header_label": "File Type",
			"jsonpath":  "fileType" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "fileStatusDesc",
			"header_label": "File Status",
			"jsonpath":  "fileStatusDesc" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "recordCount",
			"header_label": "Record Count",
			"jsonpath":  "recordCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "mcoCount",
			"header_label": "MCO Count",
			"jsonpath":  "mcoCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "pmPmFlg",
			"header_label": "PMPM",
			"jsonpath":  "pmPmFlg" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "createddate",
			"header_label": "Created Date",
			"jsonpath":  "createddate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		}
    ],
	"buttons": [],
    "apiDetails": "files.json",
	"pageName": "billingFileListView",
	"orderByColumn": ["createddate"],
	"orderBy": ["desc"]
}